import { useState } from "react";
import { submitContact } from "@/lib/api";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [status, setStatus] = useState("idle");

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    try {
      await submitContact(form);
      setStatus("done");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch { setStatus("error"); }
  };

  return (
    <div data-testid="contact-page" className="pt-28 lg:pt-44 pb-28">
      <section>
        <div className="max-w-[1100px] mx-auto px-6 sm:px-10">
          <div className="label-eyebrow">Contact</div>
          <h1 className="serif mt-7 text-[48px] sm:text-[80px] leading-[1] tracking-tight">
            Send a <span className="italic">note</span>.
          </h1>
          <p className="mt-12 max-w-xl text-[18px] leading-[1.8] text-[#2E2B27]">
            For appointments, use the Book page. For anything else — a question about a treatment, an artwork enquiry, or just to say hello — leave me a note. I reply personally.
          </p>
        </div>
      </section>

      <section className="mt-16">
        <div className="max-w-[1100px] mx-auto px-6 sm:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <form onSubmit={submit} className="lg:col-span-7 space-y-6" data-testid="contact-form">
            <div>
              <label className="label-eyebrow" htmlFor="name">Your name</label>
              <input id="name" required data-testid="contact-name" className="input-soft" value={form.name} onChange={update("name")} />
            </div>
            <div>
              <label className="label-eyebrow" htmlFor="email">Email</label>
              <input id="email" type="email" required data-testid="contact-email" className="input-soft" value={form.email} onChange={update("email")} />
            </div>
            <div>
              <label className="label-eyebrow" htmlFor="phone">Phone (optional)</label>
              <input id="phone" data-testid="contact-phone" className="input-soft" value={form.phone} onChange={update("phone")} />
            </div>
            <div>
              <label className="label-eyebrow" htmlFor="message">Your message</label>
              <textarea id="message" required rows={5} data-testid="contact-message" className="input-soft resize-none" value={form.message} onChange={update("message")} />
            </div>
            <button type="submit" data-testid="contact-submit" disabled={status === "loading"} className="btn-primary">
              {status === "loading" ? "Sending…" : status === "done" ? "Sent — thank you" : "Send your note"}
            </button>
            {status === "error" && <p className="text-[13px] text-[#A96A53]">Something went wrong. Please try again.</p>}
          </form>

          <aside className="lg:col-span-5 space-y-10">
            <div>
              <div className="label-eyebrow">Studio</div>
              <p className="serif mt-3 text-[22px] leading-snug">Bondi Beach<br/>Sydney, Australia</p>
              <p className="text-[13px] text-[#55524C] mt-2">For your privacy and ours, the exact address is shared on booking confirmation.</p>
            </div>
            <div>
              <div className="label-eyebrow">Hours</div>
              <p className="mt-3 text-[15px] leading-relaxed">Tue – Sat · By appointment only</p>
            </div>
            <div>
              <div className="label-eyebrow">A private space</div>
              <p className="mt-3 text-[15px] leading-relaxed text-[#55524C]">
                We see one woman at a time. New clients are gently welcomed through a short introduction on the Book page.
              </p>
            </div>
          </aside>
        </div>
      </section>
    </div>
  );
}
